//@import dependencies
import React, {useEffect, useState} from 'react'
import { buildStyles, CircularProgressbar } from 'react-circular-progressbar'
import { useTranslation } from 'react-i18next'
import { Accordion, Button, Card } from 'react-bootstrap';
import { customs } from 'app_config/globals';
import { useColors } from 'app_hooks/useColors'
//@end

//@import components
import AlertComponent from 'app_components/commons/alert'
// import GraphcardCommon from 'app_components/commons/graphcard'
import ActivitySummarySkeleton from './activitySummarySkeleton'
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import TextComponent from 'app_components/commons/TextComponent/TextComponent'
import { IActivitySummary } from 'app_types/campus/academic/activitySummaryTypes'
import './../activitySummaryModule.scss'
import { AiOutlineCloseCircle, AiOutlinePlusCircle } from 'react-icons/ai';
import { BsInfoCircleFill } from 'react-icons/bs';

// @ADD Component types
interface IActivitySummaryModuleLayoutProps {
  defaultStatus: boolean
  activityData: IActivitySummary | null
  chartOptions: any
  status: 'loading' | 'error' | null
}

const ActivitySummaryModuleLayout: React.FC<IActivitySummaryModuleLayoutProps> = (props) => {

  const [colors] = useColors()
  const [activeKey, setActiveKey] = useState<string |undefined>(undefined)
  const {activityData, defaultStatus} = props;

  useEffect(() => {
    const _key = defaultStatus ? '0' : undefined
    setActiveKey(_key)
  }, [defaultStatus])

  const { t } = useTranslation()

  const handleOnSelect = (e: any) => {
    setActiveKey(e)
  }

  const renderIcon = () => {
    if (activeKey) {
      return (<AiOutlineCloseCircle size={25} />)
    }
    return (<AiOutlinePlusCircle size={25} />)
  }

  return (
    <div className='activity_summary-component'>
      <Accordion activeKey={activeKey} onSelect={handleOnSelect}>
        <Card>
          <Card.Header>
            <Accordion.Toggle as={Card.Header} eventKey={'0'}>
              <div>{t('modules.activity_summary.title')}</div>
              <div className='icon'>
                {renderIcon()}
              </div>
            </Accordion.Toggle>
          </Card.Header>
          <Accordion.Collapse eventKey="0">
            <Card.Body>
              {props.status === 'loading' ? (
                <ActivitySummarySkeleton />
              ) : (
                <>
                  {activityData ? (
                    <>
                      {/* {activityData?.progress !== null && activityData?.progress !== undefined ? (
                        <div className='item-activity-summary-graphic'>
                          <TextComponent type='text'>{t('modules.activity_summary.items.progress')}:</TextComponent>
                          <CircularProgressbar
                            value={Math.round(activityData?.progress.value)}
                            text={`${Math.round(activityData?.progress.value)}%`}
                            styles={buildStyles({
                              textSize: '2rem',
                              pathColor: activityData?.progress.pathColor || undefined,
                              textColor: activityData?.progress.textColor || undefined,
                            })}
                          />
                        </div>
                      ) : null} */}
                      {activityData?.progress !== undefined && activityData?.progress !== null ? (
                        <div className='item-activity-summary'>
                          <TextComponent type='text'><b>{t('modules.activity_summary.items.progress')}:</b></TextComponent>
                          <TextComponent type='text' className='content'>{Math.round(activityData?.progress.value)}%</TextComponent>
                        </div>
                      ): null}
                      {/* {activityData?.attendanceInformation ? (
                        <div className='item-activity-summary'>
                          <TextComponent type='text'><b>Asistencias cumplidas:</b></TextComponent>
                          <TextComponent type='text' className='content'>{activityData?.attendanceInformation?.attended}/{activityData?.attendanceInformation?.total}</TextComponent>
                        </div>
                      ): null} */}
                      {activityData?.attendance !== undefined ? (
                        <div className='item-activity-summary'>
                          <TextComponent type='text'><b>Asistencia:</b></TextComponent>
                          <TextComponent type='text' className='content'>{activityData?.attendance}%</TextComponent>
                        </div>
                      ): null}
                      {/* {activityData?.activities !== undefined ? (
                        <div className='item-activity-summary'>
                          <TextComponent type='text'><b>Actividades:</b></TextComponent>
                          <TextComponent type='text' className='content'>{activityData?.activities}</TextComponent>
                        </div>
                      ): null} */}
                      {activityData?.finalNote ? (
                        <div className='item-activity-summary'>
                          <TextComponent type='text'><b>Nota promedio del programa:</b></TextComponent>
                          <TextComponent type='text' className='content'>{activityData?.finalNote}/100</TextComponent>
                        </div>
                      ): null}
                      {activityData?.certification?.label && activityData?.certification?.exam !== undefined ? (
                        <div className='item-activity-summary'>
                          <TextComponent type='text'><b>{activityData?.certification?.type === 'academic' ? 'Nota de examen' : 'Nota examen auditoria'}:</b></TextComponent>
                          <TextComponent type='text' className='content'>{activityData?.certification?.exam}/100</TextComponent>
                        </div>
                      ): null}
                      {activityData?.auditorCertification?.label && activityData?.auditorCertification?.exam !== undefined ? (
                        <div className='item-activity-summary'>
                          <TextComponent type='text'><b>Nota examen de auditoria:</b></TextComponent>
                          <TextComponent type='text' className='content'>{activityData?.auditorCertification?.exam}/100</TextComponent>
                        </div>
                      ): null}
                      {activityData?.emissionCertificate?.label ? (
                        <div className='item-activity-summary'>
                          <TextComponent type='text'><b>{t('modules.activity_summary.items.certificateIssueState')}:</b></TextComponent>
                          <TextComponent type='text' className='content'>{activityData?.emissionCertificate?.label}</TextComponent>
                        </div>
                      ): null}

                      {customs?.certificationCriteria ? (
                        <div className='activity-more-info'>
                          <Accordion>
                            <Card>
                              <Card.Header>
                                <Accordion.Toggle as={Button} eventKey={'1'} size='small' variant='link'>
                                  Nota <BsInfoCircleFill color={colors.primary} />
                                </Accordion.Toggle>
                              </Card.Header>
                              <Accordion.Collapse eventKey="1">
                                <Card.Body>
                                  <small>
                                    Para verificar el o los  certificados que aplican para el programa de formación cursado por el estudiante, revise los criterios de aprobación y certificación haciendo click <a href={customs?.certificationCriteria} target='_blank' rel="noreferrer">aquí</a>
                                  </small>
                                </Card.Body>
                              </Accordion.Collapse>
                            </Card>
                          </Accordion>
                        </div>
                      ): null}

                      {/* {activityData?.note ? (
                        <div className='item-activity-summary'>
                          <TextComponent type='text'>{t('modules.activity_summary.items.note')}:</TextComponent>
                          <TextComponent type='text' className='content'>{activityData?.note}</TextComponent>
                        </div>
                      ) : null} */}

                      {/* {activityData?.includeAuditorData ? (
                        <div className='item-activity-summary'>
                          <TextComponent type='text'>{t('modules.activity_summary.items.auditorExam')}:</TextComponent>
                          <TextComponent type='text' className='content'>{activityData?.auditorExam}</TextComponent>
                        </div>
                      ) : null} */}

                      {/* {activityData?.attendance ? (
                        <div className='item-activity-summary'>
                          <TextComponent type='text'>{t('modules.activity_summary.items.attendance')}:</TextComponent>
                          <TextComponent type='text' className='content'>{activityData?.attendance}</TextComponent>
                        </div>
                      ): null} */}
                      {/* {activityData?.exam ? (
                        <div className='item-activity-summary'>
                          <TextComponent type='text'>{t('modules.activity_summary.items.exam')}:</TextComponent>
                          <TextComponent type='text' className='content'>{activityData?.exam}</TextComponent>
                        </div>
                      ): null} */}
                      {/* {activityData?.certificate ? (
                        <div className='item-activity-summary'>
                          <TextComponent type='text'>{t('modules.activity_summary.items.certificate')}:</TextComponent>
                          <TextComponent type='text' className='content'>{activityData?.certificate}</TextComponent>
                        </div>
                      ): null} */}

                      {/*(activityData?.auditorCertificate?.isAuditor || activityData?.auditorCertificate) && (
                        <>
                          <hr />
                          {activityData?.auditorExam ? (
                            <div className='item-activity-summary'>
                              <TextComponent type='text'>{t('modules.activity_summary.items.certificateIssueState')}:</TextComponent>
                              <TextComponent type='text' className='content'>{activityData?.auditorExam}</TextComponent>
                            </div>
                          ): null}
                          { {activityData?.auditorCertificate ? (
                            <div className='item-activity-summary'>
                              <TextComponent type='text'>{t('modules.activity_summary.items.auditorCertificate')}:</TextComponent>
                              <TextComponent type='text' className='content'>{activityData?.auditorCertificate}</TextComponent>
                            </div>
                          ): null} }
                        </>
                      )*/}

                      {/* {activityData?.programFinalState ? (
                        <div className='item-activity-summary'>
                          <TextComponent type='text'>{t('modules.activity_summary.items.programFinalState')}:</TextComponent>
                          <TextComponent type='text' className='content'>{activityData?.programFinalState}</TextComponent>
                        </div>
                      ) : null}
                      {activityData?.certificateIssueState ? (
                        <div className='item-activity-summary'>
                          <TextComponent type='text'>{t('modules.activity_summary.items.certificateIssueState')}:</TextComponent>
                          <TextComponent type='text' className='content'>{activityData?.certificateIssueState}</TextComponent>
                        </div>
                      ) : null} */}
                    </>
                  ) : (
                    <AlertComponent
                      type='warning'
                      title={t('modules.activity_summary.no_data')}
                    />
                  )}
                  {/* {props.activityData ? (
                    <GraphcardCommon
                      type='bars'
                      data={props.activityData}
                      options={props.chartOptions}
                    />
                  ): (

                  )} */}
                </>
              ) }
            </Card.Body>
          </Accordion.Collapse>
        </Card>


      </Accordion>
    </div>
  )
}

export default ActivitySummaryModuleLayout
